import { allWeeks } from './2024NFLSchedule.js';

export default {
  setCurrentSchedule(context) {
    console.group("setCurrentSchedule");

    const season = context.rootGetters["seasons/currentSeason"];
    console.info("current season = ", season)

    console.info("schedulesList = ", context.getters.schedulesList);
    const schedule = context.getters.schedulesList.filter((schedule) => {
      return schedule[0].seasonId === season.seasonId;
    });

    if (schedule.length === 0) {
      console.info("no active schedule, loading hard-coded schedule: ", allWeeks);

      for ( var i = 0; i < allWeeks.length; i++ ) {
        context.commit("ADD_SCHEDULE_WEEK", allWeeks[i]);
      }

      context.dispatch("saveSchedule", context.getters.currentSchedule);

      // console.info("no active schedule, clearing currentSchedule");
      // context.commit("CLEAR_CURRENT_SCHEDULE");

      // console.info("currentSchedule")
      // console.table(context.getters.currentSchedule);
  
      // context.commit("CLEAR_CURRENT_SCHEDULE");
    } else if (schedule.length > 1) {
      console.info("More than one schedule (" + schedule.length + ") for season " + season.seasonId + ", clearing active schedule");
      context.commit("CLEAR_CURRENT_SCHEDULE");
    } else {
      // we expect to have 1 schedule per season
      console.info("Setting current schedule to schedule[0]:")
      console.table(schedule[0]);
      context.commit("SET_CURRENT_SCHEDULE", schedule[0]);
    }

    console.log("setCurrentSchedule: schedule = ");
    console.table(context.getters.currentSchedule);
    console.groupEnd();
  },
  loadSchedule(context, schedule) {
    console.group("loadSchedule");
    context.commit("LOAD_SCHEDULE", schedule);
    console.groupEnd();
  },
  async loadSchedules(context) {
    console.group("loadSchedules");

    const response = await fetch(
      `https://ironman-2021-7de88-default-rtdb.firebaseio.com/schedules.json`
    );

    const responseData = await response.json();
    console.info("responseData = ", responseData);

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to fetch schedules."
      );
      throw error;
    }

    // successfully retrieved seasons, clear the current ones
    context.dispatch("clearSchedules");

    if (responseData !== null) {
      for (const key in responseData) {
        const schedule = [];

        for (var i = 0; i < responseData[key].games.length; i++) {
          const game = new Object;

          game.seasonId = key;
          game.weekNumber = responseData[key].games[i].weekNumber;
          game.points = responseData[key].games[i].points;
          game.gameId = responseData[key].games[i].gameId;
          game.home = responseData[key].games[i].home;
          game.visitor = responseData[key].games[i].visitor;
          game.winner = responseData[key].games[i].winner ? responseData[key].games[i].winner : "";

          schedule.push(game);
        }

        context.dispatch("loadSchedule", schedule);
      }
    }

    console.info("schedulesList = ", context.getters.schedulesList);

    context.dispatch("setCurrentSchedule");
    console.info("currentSchedule: ", context.getters.currentSchedule);

    console.groupEnd();
  },
  clearSchedules(context) {
    console.group("clearSchedules");
    context.commit("CLEAR_ALL_SCHEDULES");
    console.groupEnd();
  },
  async saveSchedule(context, schedule) {
    console.group("saveSchedule");

    const token = context.rootGetters.token;
    let message = null;
    const season = context.rootGetters["seasons/currentSeason"];
    console.info("current season = ", season)

    // saving schedule, it should have a seasonId (that's the key)
    if (schedule[0].seasonId === null) {
      message = "Unable to add Schedule, seasonId is null";
    } else {
      console.info("Storing schedule for season: ", schedule[0].seasonId);
    }

    if (message !== null) {
      const error = new Error(message);
      throw error;
    }

    // This is checking if we have a schedule already so we know if we need to update it or add it to the list of schedules (in Vue, not in DB)
    const newSchedules = context.getters.schedulesList.filter((schedule) => {
      return schedule[0].seasonId === season.seasonId;
    });

    console.info("Saving schedule (total of ", schedule.length, "games) to DB: ", schedule);
    console.info("Token = ", token);

    // we do a PUT here (not a POST), since we are defining the unique key ourselves to be seasonID (only one schedule per seasonId)
    const response = await fetch(
      `https://ironman-2021-7de88-default-rtdb.firebaseio.com/schedules/${schedule[0].seasonId}.json?auth=` + token,
      {
        method: "PUT",
        body: JSON.stringify({
          games: schedule,
        }),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(responseData.message || "Failed to save schedule for season " + schedule[0].seasonId + ".");
      throw error;
    }

    console.info("responseData = ", responseData);
    if ( newSchedules.length === 0 ) {
      console.info("saved a new Schedule, adding to schedules list")
      context.dispatch("loadSchedule", schedule); // add it to the schedulesList
    } else {
      console.info("saved an existing Schedule, update it in the schedules list")
      context.dispatch("replaceSchedule", schedule);
    }

    if ( schedule[0].seasonId === season.seasonId ) {
      // This schedule is the current season, set current Schedule
      console.info("saved schedule for current season, setting currentSchedule")
      context.dispatch("setCurrentSchedule");
    }

    console.groupEnd();
  },
  replaceSchedule(context, schedule) {
    console.group("replaceSchedule");
    const schedulesList = context.getters.schedulesList;
    for (var i = 0; i < schedulesList.length; i++) {
      if ( schedulesList[i][0].seasonId === schedule[0].seasonId ) {
        // replace this one
        console.info("replacing schedule for season ", schedule[0].seasonId);

        for (var j = 0; j < schedule.length; j++) {
          Object.assign(schedulesList[i][j], schedule[j]);
        }

        console.info("new schedule")
        console.table(schedulesList[i]);
      }
    }

    console.groupEnd();
  },
};
